import { Trans } from "@lingui/macro";
import { IApiSmpGptAgent } from "@smp/api";
import { UiButton, UiIconButton, UiTypography } from "@smp/ui";
import { IconCheck, IconSettings } from "@tabler/icons-react";
import { FC } from "react";

import classes from "./agent_card.module.css";

export interface IAgentCardProps {
  agent: IApiSmpGptAgent;
  idx: number;
  isSaved?: boolean;
  onEdit: (agent: IApiSmpGptAgent) => void;
  onGenerate: (agent: IApiSmpGptAgent) => void;
}

export const AgentCard: FC<IAgentCardProps> = ({
  agent,
  idx,
  onEdit,
  onGenerate,
  isSaved,
}) => (
  <div className={classes.container}>
    <div className={classes.head}>
      {!isSaved ? (
        <UiTypography className={classes.head__title}>
          <Trans>Preset</Trans> {idx + 1}
        </UiTypography>
      ) : (
        <UiTypography className={classes.head__saved}>
          <IconCheck size={16} />
          <Trans>Saved</Trans>
        </UiTypography>
      )}
    </div>

    <UiIconButton
      color="primary"
      className={classes.settingsBtn}
      onClick={() => onEdit(agent)}
    >
      <IconSettings />
    </UiIconButton>

    <UiTypography className={classes.name}>
      {agent.params?.context?.niche}
    </UiTypography>

    <div className={classes.footer}>
      <UiButton
        variant="contained"
        color="success"
        size="large"
        className={classes.btn}
        onClick={() => onGenerate(agent)}
      >
        <Trans>Generate posts</Trans>
      </UiButton>
    </div>
  </div>
);
